import React, { PureComponent } from 'react';
import SignupFormContainer from '../components/signUp/SignupFormContainer';
export default class Signup extends PureComponent {
  render() {
    return (
      <div className="page-wrapper login-page sign-up">
        <div className="block image-box">
          <div className="background-image" />
          <div className="background-title">
            <div className="background-highlight">Welcome!</div>
            <div className="background-highlight full-width">Let's start</div>
          </div>
        </div>
        <div className="block content-wrapper">
          <div>
            <SignupFormContainer />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Signup.js